/**
 * The Upsell stories already use this component
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { cva } from '@/styled-system/css';

export const constrainedWidthSpacer = cva({
    base: {
        minHeight: '{sizes.constrainedWidthSpacerMinHeight}',
        maxWidth: '{sizes.constrainedWidthSpacerMaxWidth}',
        marginBottom: 'lg',
        paddingLeft: {
            base: 0,
            smToXl: '{sizes.400}',
        },
        paddingRight: {
            base: 0,
            smToXl: '{sizes.400}',
        },
        '@media (max-width: 650px)': {
            order: 2,
        },
    },
});
